<page-grid
  [gridConfig]="gridConfig"
  (gridEvent)="handleCreateDialog()"
  (gridClickColumn)="handleItemClick($event)">
  <ng-template #actionItem let-item="item">
    <button color="primary" data-testid="adx-service-history-button" aria-label="ADX Service History"
            type="submit" mat-icon-button
            (click)="handleHistoryClick(item?.id)"
            cdkFocusInitial matTooltip="Booking History">
      <mat-icon>history</mat-icon>
    </button>
    @if (loggedInUserHasDirectorOrFinanceOrManagerRole()) {
      <button color="primary" data-testid="adx-booking-payments-button" aria-label="Create Payment For Booking"
              type="submit" mat-icon-button
              (click)="handleServicePayments(item)"
              [disabled]="true"
              cdkFocusInitial matTooltip="Create Payment For Booking">
        <mat-icon fontIcon="payments"></mat-icon>
      </button>
      <button color="primary" data-testid="adx-manage-service-virtual-credit-card-button"
              aria-label="Manage Virtual Credit Card"
              type="submit" mat-icon-button
              (click)="manageServiceVirtualCreditCardClick(item?.id)"
              cdkFocusInitial matTooltip="Manage Virtual Credit Card">
        <mat-icon>credit_card</mat-icon>
      </button>
      <button color="primary" data-testid="delete-adx-booking-button" aria-label="Delete Booking"
              type="submit" mat-icon-button
              (click)="handleDeleteService(item)"
              cdkFocusInitial matTooltip="Delete Booking">
        <mat-icon fontIcon="delete"></mat-icon>
      </button>
    }
  </ng-template>
</page-grid>
